import { useEffect, useState } from 'react';
import { adminLog, adminLogError } from '../lib/adminLog';

export interface AccessIdentity {
  email: string;
}

export function useAccessIdentity(enabled: boolean) {
  const [user, setUser] = useState<AccessIdentity | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    if (import.meta.env.DEV && import.meta.env.VITE_LOCAL_ADMIN_EMAIL) {
      adminLog('session.local_ready');
      setUser({ email: import.meta.env.VITE_LOCAL_ADMIN_EMAIL });
      setLoading(false);
      return;
    }

    fetch('/api/admin/session', { credentials: 'same-origin' })
      .then(async (response) => {
        if (!response.ok) throw new Error('Cloudflare Access session is unavailable.');
        return response.json() as Promise<AccessIdentity>;
      })
      .then((identity) => {
        adminLog('session.ready', { email: identity.email });
        setUser(identity);
      })
      .catch((caught: Error) => {
        adminLogError('session.failed', caught);
        setError('We could not open the website editor. Please try signing in again.');
      })
      .finally(() => setLoading(false));
  }, [enabled]);

  return { user, loading, error };
}
